import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const PROGRAM_SECTIONS_I18N_NAMESPACE = '@mc/educator/programSections'

export const i18nInstance = registerI18nResources({
  namespace: PROGRAM_SECTIONS_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
